import script from "./GetFullAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./GetFullAccess.vue?vue&type=script&setup=true&lang=js"

import "./pill.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__